import styled from '@emotion/styled';
import { colors } from '@jonni/theme/colors';
import { Box, Button, Grid2, InputAdornment, Paper, Theme } from '@mui/material';
import blueWhatsapp from 'assets/blueWhatsapp.svg';
import businessCard from 'assets/businessCard.svg';
import calendarIcon from 'assets/calendarIcon.svg';
import cancelledCheckExmp from 'assets/cancelledCheckExmp.svg';
import done from 'assets/done.svg';
import gift from 'assets/gift.svg';
import handsShake from 'assets/handsShake.svg';
import headerLogo from 'assets/headerLogo.svg';
import info from 'assets/info.svg';
import lock from 'assets/lock.svg';
import mursheCaseIcon from 'assets/mursheCase.svg';
import paturCaseIcon from 'assets/paturCase.svg';
import privacy from 'assets/privacy.svg';

export const StyledStepFooterText = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  color: '#888',
  fontSize: '14px',
  padding: theme?.spacing(0, 4),
  alignSelf: 'center',
  textAlign: 'center',
  marginTop: '15px',
  whiteSpace: 'pre-line',
  [theme?.breakpoints.down('sm')]: {
    order: -1,
    marginBottom: theme?.spacing(3),
    padding: theme?.spacing(0, 'auto'),
  },
}));

export const StyledStepWrapper = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  margin: theme?.spacing(10, 'auto', 1.6),
  minHeight: theme?.spacing(64),
  maxWidth: theme?.spacing(76),
  animation: 'fadeIn 0.3s ease-in-out',
  [theme?.breakpoints.down('md')]: {
    minHeight: '75vw',
  },
  '@keyframes fadeIn': {
    from: {
      opacity: 0,
      transform: 'translateY(10px)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  '&.exit': {
    animation: 'fadeOut 0.3s ease-in-out',
  },
  '@keyframes fadeOut': {
    from: {
      opacity: 1,
      transform: 'translateY(0)',
    },
    to: {
      opacity: 0,
      transform: 'translateY(-10px)',
    },
  },
}));

export const BlueWhatsappIcon = styled(blueWhatsapp)<{ theme?: Theme }>(({ theme }) => ({
  margin: '0 auto',
  display: 'flex',
  [theme?.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const HeaderContainer = styled(Box)({
  display: 'flex',
});

export const OnboardingLayoutBodyWrapper = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  padding: '50px 0',
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  [theme?.breakpoints.down('md')]: {
    padding: '0px',
  },
}));

export const JonniLogo = styled(headerLogo)``;

export const HeaderLogo = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  margin: '0 auto',
  display: 'flex',
  [theme?.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

export const Done = styled(done)`
  margin: 0 -10px;
`;

export const StyledOverlay = styled(Box)({
  position: 'absolute',
  background: '#ffffff9c',
  width: '100%',
  height: '100%',
  zIndex: 2,
  left: 0,
  top: 0,
});

export const LoaderWrapper = styled(Box)({
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const OnboardingLayoutStepContainer = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  position: 'relative',
  width: '69%',
  maxWidth: '1000px',
  borderRadius: theme?.spacing(0.5),
  border: `1px solid ${colors.light.lightBorder}`,
  background: theme?.palette.background.paper,
  padding: theme?.spacing(10.6, 8, 6),
  minHeight: '850px',
  [theme?.breakpoints.down('md')]: {
    padding: theme?.spacing(6, 3),
    width: '100%',
    border: 'none',
    marginTop: '0px',
  },
  [theme?.breakpoints.down('sm')]: {
    padding: theme?.spacing(7, 3),
  },
}));

export const StepWrapper = styled(Box)({
  margin: '0 auto',
});

export const OnboardingLayoutBackgroundWrapper = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  width: '100%',
  background: '#fafafa',
  height: '100%',
  position: 'fixed',
  start: 0,
  display: 'flex',
  [theme?.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const OnboardingLayoutBlueBackground = styled(Box)({
  background: colors.light.primary,
  width: '45%',
});

export const MonthlyIncomeStepContainer = styled(Box)({
  marginTop: '56px',
});

export const MonthlyIncomeLoadingContainer = styled(Box)({
  height: '100%',
  marginTop: '150px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const MonthlyIncomeItem = styled(Box)<{ checked?: boolean }>(({ checked }) => ({
  display: 'flex',
  alignItems: 'center',
  marginTop: '24px',
  cursor: 'pointer',
  border: checked ? `1px solid ${colors.light.primary}` : `1px solid ${colors.light.borderGray}`,
  backgroundColor: checked ? colors.light.lightGray : '#fff',
  padding: '16px',
  borderRadius: '4px',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: checked ? colors.light.lightGray : colors.light.lightBackground,
  },
}));

export const VerificationTryDifferntNumberButton = styled('span')<{ theme?: Theme }>(({ theme }) => ({
  textDecoration: 'underline',
  cursor: 'pointer',
  marginTop: '10px',
}));

export const VerificationPhoneNumberText = styled('span')<{ theme?: Theme }>(({ theme }) => ({
  color: theme?.palette.text.secondary,
  fontWeight: 500,
  fontSize: '16px',
  marginInlineStart: theme?.spacing(1),
}));

export const VerificationResendCodeButton = styled(Button)<{ theme?: Theme }>(({ theme }) => ({
  color: colors.light.primary,
  fontSize: '16px',
  fontWeight: 500,
  display: 'flex',
  margin: '0 auto',
  textDecoration: 'underline',
  marginTop: theme?.spacing(10),
}));

export const WelcomeSubmitButtonContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  margin: '50px auto',
});

export const WelcomeFooterText = styled(StyledStepFooterText)({
  marginBottom: '18px',
});

export const WelcomeContainer = styled(Box)({
  marginTop: '-50px',
});

export const WelcomeLockIcon = styled(lock)({
  width: '27px',
  height: '40px',
  margin: '-28px',
});

export const WelcomePrivacyIcon = styled(privacy)({
  width: '22px',
  height: '40px',
  margin: '-28px',
});

export const WelcomeBusinessCardIcon = styled(businessCard)({
  width: '27px',
  height: '40px',
  margin: '-28px',
});

export const GiftDetailsIconContainer = styled(Box)({
  textAlign: 'center',
  marginBottom: '15px',
  marginTop: '-35px',
});

export const GiftDetailsSVG = styled(gift)({
  width: '210px',
  height: '220px',
});

export const GiftDetailsDescription = styled(Box)({
  textAlign: 'center',
  marginBottom: '15px',
  marginTop: '50px',
  fontSize: '28px',
  lineHeight: '35px',
  color: colors.light.darkBlue,
  fontWeight: 'bold',
});

export const DoneIconContainer = styled(Box)({
  textAlign: 'center',
  marginBottom: '15px',
});

export const DoneHandsShakeIcon = styled(handsShake)({
  width: '175px',
  height: '175px',
});

export const DoneStepContainer = styled(Box)({
  margin: '80px auto',
  height: '490px',
});

export const StyledWrapperStep = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  margin: theme?.spacing(10, 'auto', 1.6),
  minHeight: theme?.spacing(64),
  maxWidth: theme?.spacing(76),
  [theme?.breakpoints.down('md')]: {
    minHeight: '75vw',
  },
}));

export const StyledWrapperDoc = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  width: '100%',
  overflow: 'hidden',
  '& .react-transform-element': {
    width: '100%',
  },
}));

export const StyledButtonGroup = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  background: theme?.palette.background.paper,
  zIndex: 1,
  borderRadius: theme?.spacing(0.5),
  width: '100%',
  border: `1px solid ${theme?.palette.grey[200]}`,
}));

export const StyledImgViewer = styled('img')<{ theme?: Theme; rotate?: number }>(({ theme, rotate }) => ({
  width: '100%',
  borderRadius: theme?.spacing(0.5),
  transform: `rotate(${rotate}deg)`,
}));

export const ButtonSelectButton = styled(Button)<{ checked?: boolean; theme?: Theme }>(({ checked, theme }) => ({
  color: theme?.palette.text.secondary,
  fontSize: 16,
  fontWeight: 400,
  width: '100%',
  padding: '0 12px',
  border: checked ? `1px solid ${colors.light.primary}` : `1px solid ${colors.light.borderGray}`,
  backgroundColor: checked ? colors.light.lightGray : theme?.palette.background.paper,
  height: '48px',
  borderRadius: '4px',
  margin: '15px 12px',
  [theme?.breakpoints.down('sm')]: {
    margin: '15px 0px',
  },
}));

export const ButtonSelectContainer = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  [theme?.breakpoints.down('sm')]: {
    display: 'block',
  },
}));

export const StyledPaperViewer = styled(Paper)<{ theme?: Theme; padding: string }>(({ theme, padding }) => ({
  '&.MuiPaper-root': {
    backgroundColor: '#fafafa',
  },
  marginBottom: theme?.spacing(2),
  padding: padding,
}));

export const StyledForm = styled(Grid2)<{ theme?: Theme; smallMargin?: boolean }>(({ theme, smallMargin }) => ({
  marginTop: smallMargin ? theme?.spacing(-3) : '',
  marginInlineStart: '-3%',
  width: '106%',
  [theme?.breakpoints.down('md')]: {
    width: '100%',
    marginInlineStart: 0,
  },
}));

export const StyledFormItem = styled(Grid2)<{ theme?: Theme }>(({ theme }) => ({
  padding: theme?.spacing(0, '3%', 0, '3%'),
  boxSizing: 'border-box',
  marginBottom: '24px',
  [theme?.breakpoints.down('sm')]: {
    paddingInlineStart: 0,
    paddingInlineEnd: 0,
  },
}));

export const StyledSmallStartFormItem = styled(StyledFormItem)<{ theme?: Theme }>(({ theme }) => ({
  [theme?.breakpoints.down('sm')]: {
    padding: 0,
    paddingInlineEnd: '1.5%',
  },
}));

export const StyledSmallEndFormItem = styled(StyledFormItem)<{ theme?: Theme }>(({ theme }) => ({
  [theme?.breakpoints.down('sm')]: {
    padding: 0,
    paddingInlineStart: '1.5%',
  },
}));

export const StyledSmallFormItem = styled(StyledFormItem)<{ theme?: Theme }>(({ theme }) => ({
  [theme?.breakpoints.down('sm')]: {
    width: '103%',
    paddingInlineStart: '1.5%',
    paddingInlineEnd: '1.5%',
  },
}));

export const StyledLabel = styled('label')({
  alignSelf: 'flex-start',
  fontSize: '12px',
  fontWeight: 'bold',
  color: '#888',
  minHeight: '17px',
  marginBottom: '2px',
});

export const StyledErrorLabel = styled(StyledLabel)<{ theme?: Theme }>(({ theme }) => ({
  color: theme?.palette.error.main,
}));

export const StyledLink = styled('a')<{ theme?: Theme }>(({ theme }) => ({
  color: colors.light.primary,
  textDecoration: 'none',
}));

export const MursheCaseIcon = styled(mursheCaseIcon)`
  margin: 0 27px;
`;

export const PaturCaseIcon = styled(paturCaseIcon)`
  margin: 0 19px;
`;

export const AuthoritiesIdentificationDetailsDatePickerContainer = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  marginTop: theme?.spacing(-1.2),
  '& label': {
    marginBottom: theme?.spacing(-2.3),
  },
}));

export const BankDocumentUploadOrText = styled(Box)({
  alignSelf: 'center',
  textAlign: 'center',
  color: colors.light.darkBlue,
  fontSize: '15px',
  fontWeight: 700,
  margin: '15px 0px',
});

export const BankDocumentUploadInfoIcon = styled(info)({
  width: '27px',
  height: '27px',
  margin: '13px 10px 0 0',
  cursor: 'pointer',
});

export const BankDocumentUploadFormItem = styled(StyledFormItem)({
  display: 'flex',
  padding: 0,
  justifyContent: 'center',
});

export const BusinessIndustriesSearchInput = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  width: '100%',
  marginBottom: theme?.spacing(4),
  '& .MuiAutocomplete-root': {
    marginTop: theme?.spacing(2),
    '& .MuiOutlinedInput-root': {
      backgroundColor: colors.light.white,
      borderRadius: '4px',
      '& fieldset': {
        borderColor: colors.light.lightBorder,
      },
      '&:hover fieldset': {
        borderColor: colors.light.primary,
      },
      '&.Mui-focused fieldset': {
        borderColor: colors.light.primary,
      },
    },
    '& .MuiOutlinedInput-input': {
      padding: '12px 14px',
      fontSize: '16px',
      color: colors.light.darkBlue,
      '&::placeholder': {
        color: colors.light.text,
        opacity: 1,
      },
    },
  },
}));

export const BusinessIndustriesInputTitle = styled(Box)({
  fontSize: '16px',
  fontWeight: 500,
  color: colors.light.darkBlue,
  marginBottom: '4px',
});

export const CancelledCheckExmpIcon = styled(cancelledCheckExmp)({
  width: '100%',
  height: 'auto',
});

export const StyledInputFieldWrapper = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flexStart',
  position: 'relative',
  '& .MuiFormHelperText-root': {
    display: 'flex',
    justifyContent: 'flexStart',
    marginInlineStart: 0,
    fontSize: '12px',
    fontWeight: 400,
    position: 'absolute',
    top: '44px',
    margin: 0,
    color: colors.light.lightBlueText,
    lineHeight: '16px',
  },
  '& .Mui-error': {
    color: colors.light.error,
  },
}));

export const StyledInputField = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'phone',
})<{ phone?: boolean }>(({ phone }) => ({
  width: phone ? '345px' : '100%',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  '& .MuiOutlinedInput-root': {
    color: colors.light.darkBlue,
    height: '40px',
    '& fieldset': {
      borderColor: '#C8DAFE',
      borderRadius: '8px',
    },
    '&:hover fieldset': {
      borderColor: '#80afff',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#80afff',
    },
    '& input': {
      height: '40px',
      padding: '0 14px',
      boxSizing: 'border-box',
    },
  },
  // Google Places Autocomplete specific styles
  '& div[class*="-control"]': {
    borderColor: '#C8DAFE !important',
    borderRadius: '8px !important',
    height: '40px',
    minHeight: 'unset !important',
    backgroundColor: colors.light.white,
    boxShadow: 'none !important',
    padding: 0,
    '&:hover': {
      borderColor: '#80afff !important',
    },
  },
  '& div[class*="-control--is-focused"]': {
    borderColor: '#80afff !important',
    boxShadow: 'none !important',
  },
  '& div[class*="-ValueContainer"]': {
    padding: '0 14px',
    height: '40px',
  },
  '& div[class*="-Input"]': {
    color: colors.light.darkBlue,
    margin: 0,
    padding: 0,
    height: '40px',
    fontSize: '16px',
  },
  '& div[class*="-SingleValue"]': {
    color: colors.light.darkBlue,
    fontSize: '16px',
    margin: 0,
    transform: 'none',
    lineHeight: '40px',
  },
  '& div[class*="-menu"]': {
    zIndex: 999,
    marginTop: '4px',
    borderRadius: '8px',
    overflow: 'hidden',
  },
}));

export const StepHeaderContainer = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  marginBottom: theme?.spacing(7),
  whiteSpace: 'pre-line',
}));

export const StepHeaderTitle = styled('h3')({
  color: colors.light.darkBlue,
  alignSelf: 'center',
  lineHeight: '35px',
  marginBottom: '16px',
  fontSize: '28px',
  fontWeight: 'bold',
});

export const StepHeaderNoCodeText = styled('p')({
  fontSize: '16px',
  color: '#888',
  margin: 0,
  maxWidth: '450px',
  textAlign: 'center',
  lineHeight: '24px',
});

export const StepHeaderCodeText = styled('p')({
  fontSize: '16px',
  color: '#888',
  margin: 0,
  maxWidth: '350px',
  textAlign: 'center',
  lineHeight: '24px',
});

export const JonniMobileDatePickerCalendarIconInputAdornment = styled(InputAdornment)({
  margin: 0,
});

export const JonniMobileDatePickerCalendarIcon = styled(calendarIcon)``;

export const ApplicationDownloadButtonsIcon = styled(Box)({
  height: '40px',
  width: '140px',
});

export const ApplicationDownloadButtonsWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
});

export const BusinessDetailsAddressInputInfoIcon = styled(info)({
  width: '23px',
  height: '23px',
  marginTop: '3px',
  cursor: 'pointer',
});

export const BusinessDetailsAddressInputInfoIconContainer = styled(Box)({
  position: 'absolute',
  display: 'inline-flex',
  marginRight: '10px',
  marginTop: '0px',
});

export const BusinessDetailsAddressInputContainer = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  position: 'relative',
  width: '100%',
  marginBottom: '24px',
  '& svg': {
    display: 'none',
  },
  '& span': {
    display: 'none',
  },
  '& div[style]': {
    position: 'absolute',
    top: '60px',
    fontSize: '12px',
    fontWeight: 400,
    marginInlineStart: 14,
    lineHeight: '16px',
    color: colors.light.lightBlueText,
    whiteSpace: 'nowrap',
  },
  '& div[style*="color: rgb(211, 47, 47)"]': {
    color: colors.light.error,
  },
}));

export const BusinessDetailsCardContainer = styled(Button)({
  padding: '16px 0',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  fontSize: '16px',
  marginBottom: '16px',
  width: '100%',
  backgroundColor: '#fafbff',
  height: '120px',
  borderRadius: '4px',
});

export const BusinessDetailsCardType = styled(Box)({
  fontWeight: 'bold',
  fontSize: '14px',
  color: '#4357f2',
});

export const BusinessDetailsCardName = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  fontSize: '17px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '240px',
  [theme?.breakpoints.up('sm')]: {
    maxWidth: '380px',
  },
  [theme?.breakpoints.up('md')]: {
    maxWidth: '430px',
  },
}));

export const BusinessDetailsCardIdNumber = styled(Box)({
  fontSize: '15px',
});

export const BusinessDetailsCardAddress = styled(Box)({
  fontSize: '12px',
});

export const BusinessDetailsCardContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
});

export const BusinessDetailsCardWrapper = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [theme?.breakpoints.down('sm')]: {
    display: 'block',
  },
}));

export const SelectableBusinessTypeInfoIcon = styled(info)({
  width: '25px',
  height: '25px',
  margin: '0px 20px',
  cursor: 'pointer',
});

export const SelectableBusinessTypeWrapper = styled(Box)<{ icon?: boolean; theme?: Theme }>(({ icon, theme }) => ({
  display: 'flex',
  flexDirection: icon ? 'column' : 'row',
  alignItems: 'center',
  [theme?.breakpoints.down('sm')]: {
    display: 'block',
  },
}));

export const SelectableBusinessTypeButton = styled(Button)<{ checked?: boolean }>(({ checked }) => ({
  padding: '16px 0',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  fontSize: '16px',
  marginBottom: '16px',
  width: '100%',
  border: checked ? '1px solid #4357f2' : '1px solid #c3c3c3',
  backgroundColor: checked ? '#fafbff' : '#fff',
  height: '96px',
  borderRadius: '4px',
}));

export const SelectableBusinessTypeInfoButton = styled(Box)({
  alignItems: 'center',
  justifyContent: 'center',
  width: '80px',
  height: '80px',
  display: 'flex',
});

export const SelectableBusinessTypeTitle = styled(Box)({
  fontWeight: 'bold',
  fontSize: '22px',
  color: '#162154',
});

export const SelectableBusinessTypeContent = styled(Box)({
  width: '100%',
  justifyContent: 'space-between',
  display: 'flex',
  alignItems: 'center',
});

export const SelectableBusinessTypeInfoModalContent = styled(Box)({
  textAlign: 'center',
});
